import React from "react";
import { SliceConfig, Grid } from "~components";
import { PortableText } from "@portabletext/react";
import cn from "classnames";
import * as styles from "./styles.module.scss";

const FullWidthText = ({
  data: { _rawTextContent: textContent, sliceConfig }
}) => (
  <article>
    <SliceConfig config={sliceConfig}>
      <Grid narrowContent>
        <div className={cn(`b1`, styles.textContent)}>
          <PortableText value={textContent} />
        </div>
      </Grid>
    </SliceConfig>
  </article>
);

export default FullWidthText;
